import React from 'react'

const Loading = () => {
    return (
        <div className="flex w-screen h-screen justify-center items-center">
            <img src="/vinyl.svg" className="w-1/12 rot" alt="" />
        </div>
    )
}

export default Loading
